/* fs-pdp-hero — buy box interactions (visual-only) + sticky ATC reveal.
   Source: designer HTML §PDP HERO inline script, adapted to BEM + scoped. */
(function () {
  'use strict';
  var hero = document.querySelector('.fs-pdp-hero');
  if (!hero) return;

  // Picking a tier from the sticky panel toggles the buy-box qty/bulk blocks, which reflows
  // the page and moves the real Add-to-Cart row — the reveal IntersectionObserver then sees
  // it "in view" and hides the whole sticky bar mid-interaction. This flag lets a panel pick
  // suppress that one auto-hide; the reveal logic (defined lower) honours it.
  var suppressStickyHide = false;

  var mainImg = document.getElementById('fsHeroMainImg');
  var priceDisplay = hero.querySelector('[data-price-display]');

  // Subscription discount — single source of truth (theme setting `sub_discount_pct`,
  // exposed on the save badge as data-sub-pct). Falls back to 15%. Never hardcode this.
  var _badgeEl = hero.querySelector('[data-save-badge]');
  var SUB_PCT = _badgeEl ? (parseFloat(_badgeEl.getAttribute('data-sub-pct')) || 15) : 15;
  var SUB_KEEP = (100 - SUB_PCT) / 100; // e.g. 15% off → keep 0.85
  // effective price (cents) for the active purchase option, given a base one-time price
  function effPrice(priceRawCents, subActive) {
    return subActive ? Math.round(priceRawCents * SUB_KEEP) : priceRawCents;
  }
  // repaint the save badge for the ACTIVE purchase option (% vs compare-at / MSRP)
  function paintSaveBadge(subActive) {
    var badge = hero.querySelector('[data-save-badge]');
    if (!badge) return;
    var pctEl = badge.querySelector('[data-save-pct]');
    // Tier products render their own "Save up to N%" badge in Liquid — the best tier's
    // discount, fixed. Leave it alone: repainting it per selection would make the badge
    // shrink as the shopper looks at cheaper tiers.
    if (hero.querySelector('.fs-pdp-hero__tiers')) return;
    // Badge shows one fixed figure — the best deal on the product (Liquid sets save_pct and
    // sub_save_pct to the same value), with a fixed "Save up to N%" prefix. It does not change
    // with the toggle, so the headline stays consistent whichever option is selected.
    var pct = parseFloat(badge.getAttribute('data-save-pct-onetime')) || 0;
    if (pct > 0) { if (pctEl) pctEl.textContent = pct; badge.hidden = false; }
    else { badge.hidden = true; }
  }

  // ---- dynamic stock label per selected variant ----
  var stockEl = hero.querySelector('[data-stock]');
  function updateStockLabel(v) {
    if (!stockEl || !v) return;
    var txt = stockEl.querySelector('[data-stock-txt]');
    if (!txt) return;
    var ships = stockEl.getAttribute('data-ships') || '';
    var shipsSuffix = ships ? ' · ' + ships : '';
    var low = parseInt(stockEl.getAttribute('data-low-threshold'), 10) || 10;
    var label;
    if (!v.available) {
      label = 'Out of Stock';
      stockEl.classList.add('is-out');
    } else {
      stockEl.classList.remove('is-out');
      if (v.inv_managed && v.inv_qty > 0 && v.inv_qty <= low) {
        label = 'Only ' + v.inv_qty + ' left' + shipsSuffix;
      } else {
        label = 'In Stock' + shipsSuffix;
      }
    }
    txt.textContent = label;
  }

  // ---- thumbnail swap (image + video) ----
  var videoSlot = document.getElementById('fsHeroVideo');
  function showImage() {
    if (videoSlot) { videoSlot.hidden = true; videoSlot.innerHTML = ''; }
    if (mainImg) mainImg.hidden = false;
  }
  function showVideo(src, poster) {
    if (!videoSlot || !src) return;
    if (mainImg) mainImg.hidden = true;
    videoSlot.hidden = false;
    videoSlot.innerHTML = '<video class="fs-pdp-hero__video-el" controls autoplay playsinline ' +
      (poster ? 'poster="' + poster + '" ' : '') +
      'src="' + src + '"></video>';
  }
  hero.querySelectorAll('.fs-pdp-hero__thumb').forEach(function (t) {
    t.addEventListener('click', function () {
      hero.querySelectorAll('.fs-pdp-hero__thumb').forEach(function (x) { x.classList.remove('is-active'); });
      t.classList.add('is-active');
      if (t.getAttribute('data-media-type') === 'video') {
        showVideo(t.getAttribute('data-video-src'), t.getAttribute('data-poster'));
        return;
      }
      var src = t.getAttribute('data-src');
      if (mainImg && src) {
        showImage();
        // Fade via a class, not mainImg.style — the element carries an inline
        // width/aspect-ratio pair for the first paint that must survive the swap.
        // The markup ships a single src (no srcset), so setting src is all it takes.
        mainImg.classList.add('is-swapping');
        mainImg.src = src;
        setTimeout(function () { mainImg.classList.remove('is-swapping'); }, 150);
      }
    });
  });

  // ---- click-to-zoom lightbox ----
  var zoomTrigger = hero.querySelector('[data-zoom]');
  if (zoomTrigger && mainImg) {
    var lb = null;
    var buildLightbox = function () {
      lb = document.createElement('div');
      lb.className = 'fs-pdp-lightbox';
      lb.setAttribute('role', 'dialog');
      lb.setAttribute('aria-modal', 'true');
      lb.setAttribute('aria-label', 'Product image zoom');
      lb.innerHTML =
        '<button type="button" class="fs-pdp-lightbox__close" aria-label="Close zoom">&times;</button>' +
        '<img class="fs-pdp-lightbox__img" alt="">';
      document.body.appendChild(lb);
      lb.addEventListener('click', function (e) {
        if (e.target === lb || e.target.classList.contains('fs-pdp-lightbox__close')) closeLightbox();
      });
    };
    var hiRes = function (src) {
      if (!src) return src;
      return /([?&])width=\d+/.test(src) ? src.replace(/([?&])width=\d+/, '$1width=1600') : src;
    };
    var openLightbox = function () {
      // don't hijack clicks while the video player is active
      if (videoSlot && !videoSlot.hidden) return;
      if (!lb) buildLightbox();
      var lbImg = lb.querySelector('.fs-pdp-lightbox__img');
      lbImg.src = hiRes(mainImg.currentSrc || mainImg.src);
      lbImg.alt = mainImg.alt || '';
      lb.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      lb.querySelector('.fs-pdp-lightbox__close').focus();
    };
    var closeLightbox = function () {
      if (!lb) return;
      lb.classList.remove('is-open');
      document.body.style.overflow = '';
      zoomTrigger.focus();
    };
    zoomTrigger.addEventListener('click', openLightbox);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && lb && lb.classList.contains('is-open')) closeLightbox();
    });
  }

  var flavourCurrent = hero.querySelector('[data-flavour-current]');
  var form = document.getElementById('fsPdpForm');
  var variantMode = form && form.getAttribute('data-variant-mode') === 'true';
  var variantIdInput = document.getElementById('fsPdpVariantId');
  var priceWas = hero.querySelector('.fs-pdp-hero__was');

  // ---- variant engine (real options) ----
  var VARIANTS = [];
  if (variantMode) {
    // script tag is rendered outside .fs-pdp-hero — query globally
    var vScript = document.querySelector('[data-fs-variants]');
    if (vScript) { try { VARIANTS = JSON.parse(vScript.textContent); } catch (e) { VARIANTS = []; } }
  }

  // read currently-selected option values across flavour pills + bundle (supply) opts, in DOM order
  function selectedOptions() {
    var opts = [];
    var fp = hero.querySelector('.fs-pdp-hero__fpill.is-active');
    var bo = hero.querySelector('.fs-pdp-hero__bundle-opt.is-popular');
    // order matters: match variant.options index. Flavour = option1, Supply = option2 (per product setup)
    if (fp) opts.push(fp.getAttribute('data-opt-value'));
    if (bo) opts.push(bo.getAttribute('data-opt-value'));
    return opts;
  }

  function findVariant(opts) {
    return VARIANTS.find(function (v) {
      return opts.every(function (val, i) { return v.options[i] === val; });
    });
  }

  // fill bundle price + per-serve + save % per supply card (dynamic, from variants)
  function paintBundlePrices() {
    if (!variantMode) return;
    var fp = hero.querySelector('.fs-pdp-hero__fpill.is-active');
    var flav = fp ? fp.getAttribute('data-opt-value') : null;
    var subActive = hero.querySelector('.fs-pdp-hero__popt.is-active[data-purchase="subscribe"]');

    hero.querySelectorAll('.fs-pdp-hero__bundle-opt').forEach(function (card) {
      var supply = card.getAttribute('data-opt-value');
      var v = VARIANTS.find(function (x) {
        return (!flav || x.options[0] === flav) && x.options[1] === supply;
      });
      if (!v) return;
      var sym = (v.price || '$').replace(/[0-9.,\s]/g, '') || '$';
      // effective price = subscribe ? SUB_PCT off : one-time
      var effective = effPrice(v.price_raw, subActive);

      // price
      var priceEl = card.querySelector('[data-supply-price]');
      if (priceEl) priceEl.textContent = sym + (effective / 100).toFixed(2);

      // per-serve = effective ÷ servings
      var servings = parseInt(card.getAttribute('data-servings'), 10);
      var perEl = card.querySelector('[data-supply-per]');
      if (perEl) {
        if (servings > 0) {
          perEl.textContent = sym + (effective / 100 / servings).toFixed(2) + ' per serve';
        } else { perEl.textContent = ''; }
      }

      // save % vs compare-at (dynamic, homepage-style)
      var saveEl = card.querySelector('[data-supply-save]');
      if (saveEl) {
        var compareRaw = parseMoney(v.compare);
        if (compareRaw && compareRaw > effective) {
          var pct = Math.round((compareRaw - effective) / compareRaw * 100);
          var amt = (compareRaw - effective) / 100;
          saveEl.textContent = 'Save ' + sym + amt.toFixed(2) + ' (' + pct + '%)';
        } else { saveEl.textContent = ''; }
      }
    });
  }

  // parse "$45.95" → 4595 (cents)
  function parseMoney(str) {
    if (!str) return 0;
    var n = parseFloat(String(str).replace(/[^0-9.]/g, ''));
    return isNaN(n) ? 0 : Math.round(n * 100);
  }

  // The sticky bar submits fsPdpForm, so it always adds the right variant, but Liquid
  // renders its price once. Without this it keeps showing the default tier's price while
  // the form points at another one — pick 12 Months and the bar still reads the 1-month
  // price. Mirror whatever the main price row currently shows. Sticky lives outside
  // .fs-pdp-hero, so query the document, not `hero`.
  function syncStickyPrice() {
    var now = document.querySelector('.fs-pdp-sticky__price-now');
    if (now && priceDisplay) now.textContent = priceDisplay.textContent;
    // Tier products suppress the buy-box struck price (each row carries its own), so
    // priceWas is empty there. Prefer the active row's <s>, fall back to the buy box.
    var stickyRow = hero.querySelector('.fs-pdp-hero__popt--tier.is-active');
    var was = document.querySelector('.fs-pdp-sticky__was');
    if (was) {
      var rowWas = stickyRow ? stickyRow.querySelector('.fs-pdp-hero__tier-totals s') : null;
      var src = rowWas ? rowWas.textContent.trim()
                       : (priceWas ? priceWas.textContent.trim() : '');
      was.textContent = src;
      was.hidden = !src;
    }
    // Per-day and saving are already rendered inside each tier row, so copy them from
    // whichever row is active rather than recomputing (one source of truth for the maths).
    var day = document.querySelector('[data-sticky-day]');
    var saved = document.querySelector('[data-sticky-saved]');
    if (!day && !saved) return;
    var rowDay = stickyRow ? stickyRow.querySelector('.fs-pdp-hero__tier-day') : null;
    var rowSaved = stickyRow ? stickyRow.querySelector('.fs-pdp-hero__tier-saved') : null;
    if (day) {
      var dTxt = rowDay ? rowDay.textContent.trim() : '';
      day.textContent = dTxt;
      day.hidden = !dTxt;
    }
    if (saved) {
      var sTxt = rowSaved ? rowSaved.textContent.replace(/\s+/g, ' ').trim() : '';
      // Measured at 390px: the info column gives the saving 99px, and the full
      // "You save $115.02 (30% off)" needs far more, so it ellipsised. Drop the prefix
      // on narrow screens — "$115.02 (30% off)" carries the same meaning next to a
      // per-day figure, and fits.
      if (sTxt && window.matchMedia('(max-width: 749px)').matches) {
        sTxt = sTxt.replace(/^[^$]*(?=[$\d])/, '').trim();
      }
      saved.textContent = sTxt;
      saved.hidden = !sTxt;
    }
    syncStickyTrigger();
  }

  // Sticky-bar select trigger label mirrors the active tier row:
  // "Annually · 12 bottles · $268.38". Mobile drops the unit noun and "Purchase" off the
  // one-time row — the two labels measured over the 175px trigger. Built from the row DOM so
  // there's one source of truth for every figure; no-op on products without the trigger.
  function syncStickyTrigger() {
    var lbl = document.querySelector('[data-sticky-trigger-lbl]');
    if (!lbl) return;
    var row = hero.querySelector('.fs-pdp-hero__popt--tier.is-active');
    if (!row) return;
    var mobile = window.matchMedia('(max-width: 749px)').matches;
    var nameEl = row.querySelector('.fs-pdp-hero__popt-lbl');
    // clone + strip the badge so it doesn't land in the trigger text
    var name = '';
    if (nameEl) {
      var c = nameEl.cloneNode(true);
      var pop = c.querySelector('.fs-pdp-hero__tier-pop');
      if (pop) pop.remove();
      name = c.textContent.replace(/\s+/g, ' ').trim();
    }
    if (mobile) name = name.replace(' Purchase', '');
    // unit count + noun sit in the sub-line ("12 Bottles Upfront · $22.37 / bottle");
    // take the text before the middot. Mobile shows just the count.
    var subEl = row.querySelector('.fs-pdp-hero__tier-sub');
    var pack = '';
    if (subEl) {
      var subTxt = subEl.textContent.split('·')[0].replace(/\s+/g, ' ').trim();
      subTxt = subTxt.replace(/\s+Upfront$/i, '');
      pack = mobile ? (subTxt.match(/\d+/) || [''])[0] : subTxt;
    }
    var totEl = row.querySelector('.fs-pdp-hero__tier-totals strong');
    var total = totEl ? totEl.textContent.trim() : '';
    lbl.innerHTML = '<b>' + name + '</b>' + (pack ? ' · ' + pack : '') + ' · <b>' + total + '</b>';
  }

  // recompute current variant → update id, price, compare, availability
  function syncVariant() {
    if (!variantMode) return;
    var v = findVariant(selectedOptions());
    if (!v) return;
    if (variantIdInput) variantIdInput.value = v.id;
    // price: if subscribe active and variant has plan allocation, JS can't know exact sub price here
    // (Shopify computes the plan discount at cart). Show one-time variant price; sub toggle keeps % note.
    var subActive = hero.querySelector('.fs-pdp-hero__popt.is-active[data-purchase="subscribe"]');
    if (priceDisplay) {
      if (subActive) {
        // SUB_PCT-off fallback display; Liquid already substitutes the real Recharge
        // plan price when a plan exists (which it does for every current product).
        var discounted = effPrice(v.price_raw, true);
        priceDisplay.textContent = formatMoney(discounted, v.price);
      } else {
        priceDisplay.textContent = v.price;
      }
    }
    if (priceWas) priceWas.textContent = v.compare || '';
    syncStickyPrice();
    // dynamic "Save $X (Y%)" label → vs compare-at, for the ACTIVE option's effective price
    var priceSave = hero.querySelector('.fs-pdp-hero__save');
    if (priceSave) {
      var cmpRaw = v.compare ? parseFloat(v.compare.replace(/[^0-9.]/g, '')) * 100 : 0;
      var effRaw = effPrice(v.price_raw, subActive);
      if (cmpRaw > effRaw) {
        var diff = cmpRaw - effRaw;
        var savePct = Math.round(diff * 100 / cmpRaw);
        priceSave.textContent = 'Save ' + formatMoney(diff, v.price) + ' (' + savePct + '%)';
        priceSave.hidden = false;
      } else {
        priceSave.hidden = true;
      }
    }
    // dynamic save badge → real % off vs compare-at (MSRP) for the ACTIVE purchase option.
    // Recompute both baselines from THIS variant, then let paintSaveBadge pick by toggle state.
    // One-time % = one-time vs MSRP; sub % = (one-time − SUB_PCT) vs MSRP. One-time never uses the sub price.
    var badge = hero.querySelector('[data-save-badge]');
    if (badge) {
      var compareRaw = v.compare ? parseFloat(v.compare.replace(/[^0-9.]/g, '')) * 100 : 0;
      var oneEff = v.price_raw;
      var subEffB = effPrice(v.price_raw, true);
      badge.setAttribute('data-save-pct-onetime', compareRaw > oneEff ? Math.round((compareRaw - oneEff) * 100 / compareRaw) : 0);
      badge.setAttribute('data-save-pct-sub', compareRaw > subEffB ? Math.round((compareRaw - subEffB) * 100 / compareRaw) : 0);
      paintSaveBadge(!!subActive);
    }
    // purchase-toggle sub-lines → dynamic per variant
    var onetimePriceEl = hero.querySelector('[data-onetime-price]');
    if (onetimePriceEl) onetimePriceEl.textContent = v.price;
    var subPriceEl = hero.querySelector('[data-sub-price]');
    if (subPriceEl) {
      var subPer = effPrice(v.price_raw, true);
      subPriceEl.textContent = formatMoney(subPer, v.price) + '/mo';
    }
    // subscribe save % (vs compare-at) — same baseline as the badge so they stay consistent
    var subSaveEl = hero.querySelector('[data-sub-save]');
    if (subSaveEl) {
      var cmp = v.compare ? parseFloat(v.compare.replace(/[^0-9.]/g, '')) * 100 : 0;
      var subEff = effPrice(v.price_raw, true);
      subSaveEl.textContent = cmp > subEff ? Math.round((cmp - subEff) * 100 / cmp) : 0;
    }
    // also keep the subscribe button's data-price in sync (used elsewhere)
    var subBtn = hero.querySelector('.fs-pdp-hero__popt[data-purchase="subscribe"]');
    if (subBtn) subBtn.setAttribute('data-price', formatMoney(effPrice(v.price_raw, true), v.price));
    var oneBtn = hero.querySelector('.fs-pdp-hero__popt[data-purchase="onetime"]');
    if (oneBtn) oneBtn.setAttribute('data-price', v.price);
    // ATC label price → matches the ACTIVE option's effective price
    var atcPriceEl = hero.querySelector('[data-atc-price]');
    if (atcPriceEl) atcPriceEl.textContent = subActive ? formatMoney(effPrice(v.price_raw, true), v.price) : v.price;
    // availability → toggle ATC
    var atc = form.querySelector('.fs-pdp-hero__atc');
    if (atc) {
      atc.disabled = !v.available;
      if (!v.available) atc.textContent = 'Sold Out';
    }
    // stock label → recompute per selected variant (dynamic)
    updateStockLabel(v);
    // ---- URL sync (?variant=ID) without reload, Shopify-standard ----
    if (window.history && window.history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({ variant: v.id }, '', url.toString());
    }
  }

  // pre-select option pills from a variant id (used on load from ?variant=)
  function selectVariantById(id) {
    var v = VARIANTS.find(function (x) { return String(x.id) === String(id); });
    if (!v) return false;
    var flav = v.options[0], supply = v.options[1];
    hero.querySelectorAll('.fs-pdp-hero__fpill').forEach(function (p) {
      var on = p.getAttribute('data-opt-value') === flav;
      p.classList.toggle('is-active', on); p.setAttribute('aria-checked', on ? 'true' : 'false');
      if (on && flavourCurrent) flavourCurrent.textContent = p.getAttribute('data-flavour') || flav;
    });
    if (supply != null) {
      hero.querySelectorAll('.fs-pdp-hero__bundle-opt').forEach(function (b) {
        b.classList.toggle('is-popular', b.getAttribute('data-opt-value') === supply);
      });
    }
    return true;
  }

  // crude money formatter: derive currency symbol from the variant's formatted price string
  function formatMoney(cents, sample) {
    var sym = (sample || '$').replace(/[0-9.,\s]/g, '') || '$';
    return sym + (cents / 100).toFixed(2);
  }

  // ---- flavour pills ----
  hero.querySelectorAll('.fs-pdp-hero__fpill').forEach(function (pill) {
    pill.addEventListener('click', function () {
      hero.querySelectorAll('.fs-pdp-hero__fpill').forEach(function (p) {
        p.classList.remove('is-active'); p.setAttribute('aria-checked', 'false');
      });
      pill.classList.add('is-active'); pill.setAttribute('aria-checked', 'true');
      if (flavourCurrent) flavourCurrent.textContent = pill.getAttribute('data-flavour') || pill.textContent.trim();
      paintBundlePrices();
      syncVariant();
    });
  });

  // ---- bundle / supply options ----
  hero.querySelectorAll('.fs-pdp-hero__bundle-opt').forEach(function (opt) {
    opt.addEventListener('click', function () {
      hero.querySelectorAll('.fs-pdp-hero__bundle-opt').forEach(function (o) { o.classList.remove('is-popular'); });
      opt.classList.add('is-popular');
      if (variantMode) {
        syncVariant();
      } else {
        var sub = hero.querySelector('.fs-pdp-hero__popt.is-active');
        var bundleSub = opt.getAttribute('data-bundle-price');
        if (priceDisplay && sub && /subscribe/i.test(sub.textContent) && bundleSub) {
          priceDisplay.textContent = bundleSub;
        }
      }
    });
  });

  // initial: honor ?variant= in URL (share/bookmark/back), then paint
  if (variantMode) {
    var urlVariant = new URLSearchParams(window.location.search).get('variant');
    if (urlVariant) selectVariantById(urlVariant);
  }
  paintBundlePrices();
  syncVariant();

  // back/forward → re-sync from URL
  window.addEventListener('popstate', function () {
    if (!variantMode) return;
    var vid = new URLSearchParams(window.location.search).get('variant');
    if (vid && selectVariantById(vid)) { paintBundlePrices(); syncVariant(); }
  });

  // ---- purchase toggle + frequency (wires real selling_plan hidden input) ----
  var planInput = document.getElementById('fsPdpSellingPlan');
  var freqWrap = hero.querySelector('[data-freq-wrap]');
  // currently selected subscription plan id (defaults to hidden input's initial value)
  var selectedPlanId = planInput ? (planInput.getAttribute('data-plan-id') || '') : '';

  // custom dropdown: [data-fs-freq-select] is the .fs-select wrapper; the hidden
  // native <select> inside is the value source. fs-select.js fires 'change' on it.
  var freqRoot = freqWrap ? freqWrap.querySelector('[data-fs-freq-select]') : null;
  var freqSelect = freqRoot ? freqRoot.querySelector('[data-fs-select-native]') : null;
  if (freqSelect && !selectedPlanId) selectedPlanId = freqSelect.value || '';

  function activeFreqPlanId() {
    return freqSelect ? (freqSelect.value || selectedPlanId) : selectedPlanId;
  }

  // frequency dropdown change (from custom fs-select → native change event)
  if (freqSelect) {
    freqSelect.addEventListener('change', function () {
      selectedPlanId = freqSelect.value || '';
      var subActive = hero.querySelector('.fs-pdp-hero__popt.is-active[data-purchase="subscribe"]');
      if (planInput && subActive) planInput.value = selectedPlanId;
      // plan price + save % live on the matching listbox <li>
      var li = freqRoot.querySelector('.fs-select__opt[data-value="' + selectedPlanId + '"]');
      var pp = li ? li.getAttribute('data-plan-price') : '';
      var ps = li ? li.getAttribute('data-plan-save') : '';
      // the selected plan drives BOTH the main price and the subscribe toggle's own price +
      // save % — otherwise the toggle stays stuck on the default plan's figure after a change.
      if (pp) {
        if (priceDisplay && subActive) priceDisplay.textContent = pp;
        var subPriceEl = hero.querySelector('[data-sub-price]');
        if (subPriceEl) subPriceEl.textContent = pp + '/mo';
      }
      var subSaveEl = hero.querySelector('[data-sub-save]');
      if (subSaveEl && ps != null) subSaveEl.textContent = ps;
    });
  }

  hero.querySelectorAll('.fs-pdp-hero__popt').forEach(function (opt) {
    opt.addEventListener('click', function () {
      hero.querySelectorAll('.fs-pdp-hero__popt').forEach(function (o) {
        o.classList.remove('is-active'); o.setAttribute('aria-checked', 'false');
      });
      opt.classList.add('is-active'); opt.setAttribute('aria-checked', 'true');
      var isSub = opt.getAttribute('data-purchase') === 'subscribe';
      // Each tier row carries its OWN plan id (no separate frequency dropdown any more),
      // so read it off the clicked row. Fall back to the legacy dropdown for products
      // still rendering the old markup.
      var rowPlanId = opt.getAttribute('data-plan-id') || '';
      if (planInput) planInput.value = isSub ? (rowPlanId || activeFreqPlanId()) : '';
      if (freqWrap) freqWrap.hidden = !isSub;
      // A tier row IS a multi-bottle supply (12-month = 12 bottles in one delivery), so the
      // row's data-qty drives the cart quantity. The stepper would let the customer multiply
      // a 12-pack into 24 bottles, and the bulk-pack ladder double-discounts on top of the
      // plan discount — hide both while a subscription tier is selected.
      var qtyBox = hero.querySelector('.fs-pdp-hero__qty');
      var bulkBox = hero.querySelector('.fs-pdp-hero__bulk');
      var qtyVal = document.getElementById('fsPdpQty');
      if (qtyBox) qtyBox.hidden = isSub;
      if (bulkBox) bulkBox.hidden = isSub;
      var rowQty = opt.getAttribute('data-qty');
      if (qtyVal) qtyVal.value = rowQty || '1';
      // Each tier is its own variant (1/3/6/12-pack), so selecting a row must switch the
      // variant the form posts — otherwise a 12-pack row would add a single bottle.
      var rowVariant = opt.getAttribute('data-variant-id');
      if (rowVariant) {
        var vInput = hero.querySelector('input[name="id"], #fsPdpVariantId');
        if (vInput) vInput.value = rowVariant;
      }
      // price: variant mode recomputes from real variant; else use static data-price
      if (variantMode) {
        paintBundlePrices(); // per-serve + save% depend on subscribe state
        syncVariant();
      } else {
        // non-variant products (e.g. Slumbra): sub price comes from the real selling-plan
        // allocation rendered in Liquid (data-price on the subscribe option). One-time uses
        // the plain variant price. Badge % is picked by toggle state from the two Liquid baselines.
        var p = opt.getAttribute('data-price');
        if (priceDisplay && p) priceDisplay.textContent = p;
        // recompute the "Save $X (Y%)" line for the active option (vs compare-at / MSRP)
        var toCents = function (s) { return s ? Math.round(parseFloat(s.replace(/[^0-9.]/g, '')) * 100) : 0; };
        var effRaw = toCents(p);
        var cmpRaw = priceWas ? toCents(priceWas.textContent) : 0;
        var saveEl = hero.querySelector('.fs-pdp-hero__save');
        if (saveEl) {
          if (cmpRaw > effRaw && effRaw > 0) {
            var diff = cmpRaw - effRaw;
            saveEl.textContent = 'Save ' + formatMoney(diff, p) + ' (' + Math.round(diff * 100 / cmpRaw) + '%)';
            saveEl.hidden = false;
          } else { saveEl.hidden = true; }
        }
        // retarget the gallery save badge to the active option's precomputed % (one-time vs sub)
        paintSaveBadge(isSub);
        var atcEl = hero.querySelector('[data-atc-price]');
        if (atcEl && p) atcEl.textContent = p;
        syncStickyPrice();
      }
    });
  });

  // ---- Sticky-bar tier picker (Option C) ----
  // A select-looking trigger in the sticky bar opens a panel of the tier rows above the bar.
  // The panel rows are built from the buy-box .fs-pdp-hero__popt--tier DOM (figures live in
  // one place) and picking one proxies a click to its buy-box row, so every existing
  // variant/plan/price handler runs unchanged. Tier products only — no trigger, no-op.
  (function stickyTierPicker() {
    var dock = document.querySelector('[data-sticky-trigdock]');
    if (!dock) return;
    var trigger = dock.querySelector('[data-sticky-trigger]');
    var sheet = dock.querySelector('[data-sticky-sheet]');
    var tierRows = Array.prototype.slice.call(hero.querySelectorAll('.fs-pdp-hero__popt--tier'));
    if (!trigger || !sheet || !tierRows.length) return;

    // Build one panel row per tier, reformatted to the approved mockup's compact shape
    // (Option C) rather than dumping the buy-box row's verbatim text — the buy box uses
    // "You save $9.58 (10% off)" and "$28.75 / bottle", which wrap in the narrow panel.
    // Mockup rows are: name [badge] / "N bottles · $X/bottle" small, and on the right
    // "$was $now" with "Save N% off" under it.
    sheet.innerHTML = tierRows.map(function (row, i) {
      var lblEl = row.querySelector('.fs-pdp-hero__popt-lbl');
      var subEl = row.querySelector('.fs-pdp-hero__tier-sub');
      var sEl = row.querySelector('.fs-pdp-hero__tier-totals s');
      var nowEl = row.querySelector('.fs-pdp-hero__tier-totals strong');
      var name = lblEl ? lblEl.cloneNode(true) : null;
      var badge = '';
      if (name) {
        var pop = name.querySelector('.fs-pdp-hero__tier-pop');
        if (pop) { badge = '<span class="fs-pdp-sticky__srbadge">' + pop.textContent.trim() + '</span>'; pop.remove(); }
      }
      var nameTxt = name ? name.textContent.replace(/\s+/g, ' ').trim() : '';
      // Compact sub-line: pack facts before the middot ("3 Bottles Upfront" → "3 bottles"),
      // then the per-unit price with the slash tightened ("$28.75 / bottle" → "$28.75/bottle").
      var sub = '';
      if (subEl) {
        var packRaw = subEl.textContent.split('·')[0].replace(/\s+/g, ' ').trim().replace(/\s+Upfront$/i, '').toLowerCase();
        var unitEl = subEl.querySelector('.fs-pdp-hero__tier-unit');
        var unitTxt = unitEl ? unitEl.textContent.replace(/\s*\/\s*/, '/').replace(/\s+/g, ' ').trim() : '';
        sub = packRaw + (unitTxt ? ' · ' + unitTxt : '');
      }
      var was = sEl ? '<s>' + sEl.textContent.trim() + '</s>' : '';
      var now = nowEl ? nowEl.textContent.trim() : '';
      // Save line = "Save N% off" only (mockup), pulled from the row's "(N% off)" fragment.
      var save = '';
      var pctEl = row.querySelector('.fs-pdp-hero__tier-pct');
      if (pctEl) {
        var pct = (pctEl.textContent.match(/\d+/) || [''])[0];
        if (pct) save = '<em>Save ' + pct + '% off</em>';
      }
      return '<button type="button" class="fs-pdp-sticky__srow" data-sticky-row="' + i + '">' +
             '<span class="fs-pdp-sticky__srl"><span class="fs-pdp-sticky__srname">' + nameTxt + badge + '</span>' +
             (sub ? '<small>' + sub + '</small>' : '') + '</span>' +
             '<span class="fs-pdp-sticky__srr">' + was + now + save + '</span>' +
             '</button>';
    }).join('');

    function markActive() {
      var activeIdx = tierRows.indexOf(hero.querySelector('.fs-pdp-hero__popt--tier.is-active'));
      sheet.querySelectorAll('.fs-pdp-sticky__srow').forEach(function (r, i) {
        r.classList.toggle('is-active', i === activeIdx);
      });
    }
    function close() { sheet.hidden = true; trigger.setAttribute('aria-expanded', 'false'); }

    // On mobile the sheet is position:fixed and must clear the sticky bar, whose height
    // varies with the trigger label (a longer "Annually · 12 Bottles · $268.38" can wrap).
    // A hardcoded CSS bottom dropped the panel onto the bar and hid the Add-to-Cart button
    // when the bar grew. Measure the bar and set the offset each time it opens instead.
    var stickyBar = document.getElementById('fsPdpSticky');
    function positionSheet() {
      if (window.matchMedia('(max-width: 749px)').matches && stickyBar) {
        sheet.style.bottom = (stickyBar.getBoundingClientRect().height + 6) + 'px';
      } else {
        sheet.style.bottom = '';
      }
    }

    trigger.addEventListener('click', function (e) {
      e.stopPropagation();
      var open = sheet.hidden;
      sheet.hidden = !open;
      trigger.setAttribute('aria-expanded', String(open));
      if (open) { positionSheet(); markActive(); }
    });
    document.addEventListener('click', close);

    sheet.addEventListener('click', function (e) {
      var r = e.target.closest('[data-sticky-row]');
      if (!r) return;
      // The buy-box row's handler toggles qty/bulk blocks → the page reflows → the reveal
      // observer would hide the whole bar. Guard it across the reflow (a couple of frames),
      // then release so normal scroll-away hiding resumes.
      suppressStickyHide = true;
      // proxy to the buy-box row — its handler switches variant/plan/price and calls
      // syncStickyPrice → syncStickyTrigger, which repaints this trigger's label.
      tierRows[+r.getAttribute('data-sticky-row')].click();
      close();
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { suppressStickyHide = false; });
      });
    });
  })();

  // On load one tier row is pre-selected in Liquid (the "Default tier" setting, 3 units),
  // but the price block, hidden
  // selling_plan input and qty were still showing the one-time defaults until the customer
  // clicked something. Fire the handler once for whichever row starts active.
  var initialOpt = hero.querySelector('.fs-pdp-hero__popt--tier.is-active');
  if (initialOpt) initialOpt.click();

  // ---- ATC confirmation (visual) ----
  document.querySelectorAll('[data-atc]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      btn.classList.add('is-added');
      setTimeout(function () { btn.classList.remove('is-added'); }, 2000);
    });
  });

  // ---- wishlist (supports both legacy [data-wish] and new [data-wishlist]) ----
  var wishBtn = hero.querySelector('[data-wish],[data-wishlist]');
  if (wishBtn) {
    wishBtn.addEventListener('click', function () {
      var on = wishBtn.classList.toggle('is-wished');
      wishBtn.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  // ---- Buy Now: add line then jump straight to checkout ----
  var buyNow = hero.querySelector('[data-buynow]');
  if (buyNow && form) {
    buyNow.addEventListener('click', function () {
      var fd = new FormData(form);
      buyNow.disabled = true;
      fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
        method: 'POST', body: fd, headers: { 'Accept': 'application/json' }
      }).then(function (r) { return r.json(); })
        .then(function () { window.location.href = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'checkout'; })
        .catch(function () { buyNow.disabled = false; form.submit(); });
    });
  }

  // ---- sticky ATC reveal ----
  // Direction-aware: when the real Add-to-Cart button is out of view AND the user
  // is scrolling DOWN, show the sticky ATC (and hide the bottom nav). When the
  // user scrolls back UP, hide the sticky ATC and let the bottom nav return —
  // even while the ATC button is still off-screen. So: scroll down = ATC bar,
  // scroll up = nav bar. Only one bar at a time.
  var sticky = document.getElementById('fsPdpSticky');
  if (sticky) {
    var atcRow = hero.querySelector('.fs-pdp-hero__atc-row') || hero.querySelector('.fs-pdp-hero__atc');
    var atcInView = false;   // is the real ATC button currently visible?
    var lastY = window.scrollY;
    var stuckOn = false;

    function setOn(on) {
      // A sticky-panel pick reflows the page; ignore the hide it triggers so the bar the
      // user is interacting with doesn't vanish under them.
      if (!on && suppressStickyHide) return;
      if (on === stuckOn) return;
      stuckOn = on;
      sticky.classList.toggle('is-on', on);
      sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
      // Hide Ella's fixed mobile bottom nav only while the ATC bar is showing.
      document.body.classList.toggle('fs-pdp-sticky-on', on);
    }

    if (atcRow && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        atcInView = entries[0].isIntersecting;
        // If the button comes back into view, always drop the sticky bar.
        if (atcInView) setOn(false);
      }, { threshold: 0 });
      io.observe(atcRow);
    }

    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var y = window.scrollY;
        var goingDown = y > lastY;
        lastY = y;
        if (atcInView) {
          setOn(false);            // ATC visible → no sticky needed
        } else if (goingDown) {
          setOn(true);             // scrolling down, ATC gone → show ATC bar
        } else {
          setOn(false);            // scrolling up → show the nav instead
        }
        ticking = false;
      });
    }, { passive: true });
  }

  // ---- quantity-upsell: block a duplicate subscription add ----
  // A quantity-upsell tier is a fixed supply ("12 bottles in one plan"). Adding the same
  // product's subscription twice would merge into a doubled quantity, silently turning a
  // 12-pack into 24. So before the add fires, check the cart: if this product already has a
  // subscription line, stop the add and tell the shopper it's already in their cart. They can
  // change the plan from the cart / customer portal instead of stacking a second one.
  var isQtyUpsell = !!hero.querySelector('.fs-pdp-hero__tiers[data-qty-upsell]');
  if (isQtyUpsell && form) {
    var currentProductId = form.getAttribute('data-product-id') || '';
    var cartUrl = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart';
    // A fixed toast pinned to the bottom of the viewport, appended to <body> — so it's visible
    // whether the shopper clicked the main Add-to-Cart (top of page) or the sticky bar (scrolled
    // down). A notice tucked inside the buy box would sit off-screen for a sticky-bar click.
    function showAlreadyInCart() {
      var box = document.querySelector('[data-atc-notice]');
      if (!box) {
        box = document.createElement('div');
        box.className = 'fs-pdp-hero__atc-notice';
        box.setAttribute('data-atc-notice', '');
        box.setAttribute('role', 'status');
        document.body.appendChild(box);
      }
      box.innerHTML = 'This subscription is already in your cart. '
        + '<a href="' + cartUrl + '" class="fs-pdp-hero__atc-notice-link">View cart</a> or '
        + '<a href="' + cartUrl.replace(/\/cart$/, '/checkout') + '" class="fs-pdp-hero__atc-notice-link">check out</a>.';
      box.hidden = false;
      clearTimeout(box._t);
      box._t = setTimeout(function () { box.hidden = true; }, 8000);
    }
    // Keep a fresh cart snapshot so the click handler can decide synchronously (Ella's own
    // submit fires immediately on click; we can't await a fetch mid-click). Refresh it on load
    // and after every cart change.
    var cartSnapshot = { items: [] };
    function refreshSnapshot() {
      return fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart.js')
        .then(function (r) { return r.json(); })
        .then(function (c) { cartSnapshot = c; })
        .catch(function () {});
    }
    refreshSnapshot();
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, refreshSnapshot);
    }
    // Duplicate = the SAME plan already in the cart. A different tier of the same product
    // (Quarterly alongside Annually) is allowed — two distinct supplies are valid.
    function samePlanInCart(planId) {
      if (!planId) return false;
      return cartSnapshot.items.some(function (it) {
        return it.selling_plan_allocation
          && it.selling_plan_allocation.selling_plan
          && String(it.selling_plan_allocation.selling_plan.id) === String(planId);
      });
    }
    // Block a duplicate at the CLICK, on document-capture — the earliest possible point. Ella's
    // product-form registers its own submit handler in capture on the form's component, which
    // runs before a form-level submit listener (document-capture precedes element-capture in the
    // propagation path). Intercepting the click on document-capture beats all of that: the submit
    // is never dispatched, so Ella's add never fires.
    //
    // Decide SYNCHRONOUSLY from the cached snapshot (kept fresh on load + every cartUpdate) so we
    // can stop the event inline — no async fetch + re-fire (that caused a double submit + a race
    // that hid the toast). One-time or a new tier → let it through untouched.
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('.fs-pdp-hero__atc.add-to-cart-button, .fs-pdp-sticky__btn[form="fsPdpForm"]');
      if (!btn || (btn.form && btn.form !== form)) return; // not our ATC
      var active = hero.querySelector('.fs-pdp-hero__popt--tier.is-active');
      var isSub = active && active.getAttribute('data-purchase') === 'subscribe';
      if (!isSub) return;                       // one-time: always allow
      if (!samePlanInCart(active.getAttribute('data-plan-id'))) return; // new tier: allow
      e.preventDefault();                       // duplicate: stop the click → no submit → no add
      e.stopImmediatePropagation();
      showAlreadyInCart();
    }, true);
  }
})();
